import React, { ChangeEvent, FC, memo, useRef } from 'react'
import { Button } from 'transfix-ui'

interface IAddAttachmentProps {
  disabled?: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  text: string
}

export const AddAttachment: FC<IAddAttachmentProps> = memo(({ disabled, onChange, text = '' }) => {
  const hiddenFileInput = useRef<HTMLInputElement>(null)
  const buttonClickHandler = () => {
    if (hiddenFileInput.current) hiddenFileInput.current.click()
  }
  return (
    <>
      <input
        onChange={onChange}
        ref={hiddenFileInput}
        accept='.pdf, .jpg, .jpeg, .png, .doc, .docx, .tiff, .heic'
        id='contained-button-file'
        multiple
        type='file'
        style={{ display: 'none' }}
      />
      <Button
        color='primary'
        size='large'
        fullWidth
        onClick={buttonClickHandler}
        disabled={disabled}>
        {text}
      </Button>
    </>
  )
})
